import React from "react";

import { ViewGrid, ViewList } from "../../../components/icons/svg/outline";
import { PROJECTS_HOME_VIEW_MODES } from "../constants";

/**
 * Card/List view toggle for Projects Home (Drive-style pill, no Auto option).
 * Card (grid) is always on the left; list on the right.
 *
 * @param {Object} props
 * @param {'list'|'card'} props.viewMode - Active view mode.
 * @param {(mode: 'list'|'card') => void} props.onChange - View mode change handler.
 * @returns {JSX.Element}
 */
const ProjectsViewToggle = ({ viewMode, onChange }) => (
  <div
    className="flex h-8 flex-shrink-0 items-center overflow-hidden rounded-full border border-gray-300 bg-white"
    role="group"
    aria-label="Project view mode"
  >
    <button
      type="button"
      className={`flex h-full items-center px-2.5 transition ${
        viewMode === PROJECTS_HOME_VIEW_MODES.CARD
          ? "bg-primary text-white"
          : "bg-white text-gray-700 hover:bg-gray-50"
      }`}
      title="Card view"
      aria-label="Card view"
      aria-pressed={viewMode === PROJECTS_HOME_VIEW_MODES.CARD}
      onClick={() => onChange(PROJECTS_HOME_VIEW_MODES.CARD)}
    >
      <ViewGrid className="h-4 w-4" aria-hidden />
    </button>
    <button
      type="button"
      className={`flex h-full items-center px-2.5 transition ${
        viewMode === PROJECTS_HOME_VIEW_MODES.LIST
          ? "bg-primary text-white"
          : "bg-white text-gray-700 hover:bg-gray-50"
      }`}
      title="List view"
      aria-label="List view"
      aria-pressed={viewMode === PROJECTS_HOME_VIEW_MODES.LIST}
      onClick={() => onChange(PROJECTS_HOME_VIEW_MODES.LIST)}
    >
      <ViewList className="h-4 w-4" aria-hidden />
    </button>
  </div>
);

export default ProjectsViewToggle;
